// The subscribing broker/lender. Pulse is the platform brand; legal and
// compliance identity always comes from the subscriber, never from Pulse.
export const subscriber = {
  companyName: 'Northstar Home Lending, LLC',
  companyShortName: 'Northstar',
  companyNmls: 'NMLS #2210457',
  licensing: 'Licensed in TX, CO, and AZ',
  equalHousing: true,
};

export const platformName = 'Pulse';
